<div
  class="oauth-consent-container tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-bg-gray-50 dark:tw-bg-gray-900">
  <div class="tw-w-full tw-max-w-md tw-px-4">
    <div *ngIf="loading" class="tw-text-center">
      <mat-spinner class="tw-mx-auto" diameter="40"></mat-spinner>
      <p class="tw-mt-4 tw-text-gray-600 dark:tw-text-gray-400">Loading application details...</p>
    </div>

    <app-alert alertType="error" *ngIf="error">
      <h3 class="tw-text-sm tw-font-medium">Authorization Error</h3>
      <p class="tw-mt-1 tw-text-sm">{{ error }}</p>
    </app-alert>

    <mat-card *ngIf="!loading && !error && clientDetails" class="tw-shadow-xl">
      <!-- Platform Logo -->
      <div class="tw-text-center tw-pt-6 tw-pb-4">
        <img
          *ngIf="!isWorkforceLogin"
          class="tw-h-8 tw-mx-auto tw-mb-6 dark:tw-hidden"
          src="../../assets/img/logo-gray.svg"
          alt="GotLiveData logo" />
        <img
          *ngIf="!isWorkforceLogin"
          class="tw-h-8 tw-mx-auto tw-mb-6 tw-hidden dark:tw-block"
          src="../../assets/img/logo-white.svg"
          alt="GotLiveData logo" />
        <img
          *ngIf="isWorkforceLogin"
          class="tw-h-8 tw-mx-auto tw-mb-6"
          src="../../assets/img/workforce_logo_white.svg"
          alt="Workforce logo" />
      </div>

      <!-- Subtle divider -->
      <div class="tw-border-t tw-border-gray-200 dark:tw-border-gray-700 tw-mx-6"></div>

      <mat-card-header class="tw-text-center tw-pb-0 tw-pt-6">
        <div class="tw-w-full">
          <mat-icon class="tw-text-6xl tw-w-20 tw-h-20 tw-mx-auto tw-mb-4 tw-text-gray-400">
            apps
          </mat-icon>
          <h1 class="tw-text-2xl tw-font-bold tw-text-gray-900 dark:tw-text-gray-100">
            {{ clientDetails.client_name }}
          </h1>
          <p class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-400 tw-mt-2">
            wants to access your {{ isWorkforceLogin ? 'Workforce.ai' : 'GotLiveData' }} account
          </p>
        </div>
      </mat-card-header>

      <mat-card-content class="tw-pt-6">
        <!-- Organization Selection (Multi-org users only) -->
        <div *ngIf="showOrgSelection" class="tw-mb-6">
          <h3 class="tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-100 tw-mb-3">
            Select Organization
          </h3>
          <div class="tw-bg-gray-50 dark:tw-bg-gray-800 tw-rounded-lg tw-p-4">
            <mat-radio-group [(ngModel)]="selectedOrgId" class="tw-flex tw-flex-col tw-gap-3">
              <mat-radio-button
                *ngFor="let org of orgs"
                [value]="org.id"
                class="tw-text-sm tw-text-gray-700 dark:tw-text-gray-300">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <mat-icon class="tw-text-base tw-text-gray-500 dark:tw-text-gray-400">
                    corporate_fare
                  </mat-icon>
                  <span class="tw-font-medium">{{ org.name }}</span>
                </div>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="tw-mb-6">
          <h3 class="tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-gray-100 tw-mb-3">
            This application will be able to:
          </h3>
          <div class="tw-bg-gray-50 dark:tw-bg-gray-800 tw-rounded-lg tw-p-4">
            <ul class="tw-space-y-2">
              <li *ngFor="let scope of scopes" class="tw-flex tw-items-start">
                <mat-icon class="tw-text-green-500 tw-mr-2 tw-text-lg tw-mt-0.5"
                  >check_circle</mat-icon
                >
                <span class="tw-text-sm tw-text-gray-700 dark:tw-text-gray-300">
                  {{ getScopeDescription(scope) }}
                </span>
              </li>
            </ul>
            <div *ngIf="!scopes || scopes.length === 0">
              <p class="tw-text-sm tw-text-gray-700 dark:tw-text-gray-300">
                Act on your behalf in this account
              </p>
            </div>
          </div>
        </div>

        <app-alert alertType="info" alertStyle="compact">
          <span class="tw-text-xs">
            By authorizing, you allow this application to access your data according to the
            permissions above. You can revoke access at any time from your account settings.
          </span>
        </app-alert>
      </mat-card-content>

      <mat-card-actions class="tw-flex tw-gap-3 tw-px-4 tw-pb-4">
        <button
          mat-raised-button
          color="primary"
          (click)="authorize()"
          [disabled]="authorizing || !selectedOrgId"
          class="tw-flex-1">
          <mat-spinner
            *ngIf="authorizing"
            diameter="20"
            class="tw-inline-block tw-mr-2"></mat-spinner>
          <span *ngIf="!authorizing">Authorize</span>
          <span *ngIf="authorizing">Authorizing...</span>
        </button>
        <button mat-stroked-button (click)="deny()" [disabled]="authorizing" class="tw-flex-1">
          Deny
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
